// 避免 options 和 mapping 分散各處，保持單一來源
const identificationOptions = [
  {
    label: '家長',
    value: 1,
  },
  {
    label: '醫療團隊',
    value: 2,
  },
];

const identificationMapping = identificationOptions.reduce((mapping, item) => {
  mapping[item.value] = item.label;

  return mapping;
}, {});

export {
  identificationOptions,
  identificationMapping,
};
